'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Matang Caste" },
  { label: "Matang Caste in Marathi" },
  { label: "Matang matrimony" },
  { label: "Matang Samaj" },
  { label: "Matang Samaj history in Marathi" },
  { label: "Matang Samaj flag" },
  { label: "Matang caste meaning in Marathi" },
  { label: "Matang caste category Marathi" },
  { label: "Hindu Matang" },
  { label: "Matang Vadhu photo" },
  { label: "Matang Vadhu Var Whatsapp group link" },
  { label: "Matang Vadhu photo Ahmednagar" },
  { label: "Pune Matang Vadhu Photo" },
  { label: "Divorced Matang Vadhu Photo" },
  { label: "Matang Vadhu Var Suchak Mandal Pune" },
  { label: "Matang Vadhu Var Suchak Mandal" },
  { label: "Matang Vadhu Var Suchak WhatsApp group" },
  { label: "Matang Vadhu Var Suchak" },
  { label: "Matang Vadhu Mumbai" },
  { label: "Matang Vadhu Var Suchak Kendra Pune" },
  { label: "Matang Vadhu in Kolhapur" },
  { label: "Matang Vadhu Satara" },
  { label: "Matang Vadhu Var WhatsApp Group Sangli" },
  { label: "Matang Vadhu Var Suchak Mandal Nashik" },
  { label: "Matang Vadhu Var Suchak Mandal Satara" },
  { label: "Matang Vadhu Var Suchak Kolhapur" },
  { label: "Matang Vadhu Var Suchak Pune" },
];

export default function MatangMatrimony() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मातंग समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="matang_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the most Trusted Matang matchmaking service in Mumbai?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted Matang matchmaking service provider in Mumbai."
                },
                {
                  question: "Which is the No. 1 Matang Matrimony site in Maharashtra?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the No. 1 Matang Matrimony site in Maharashtra."
                },
                {
                  question: "How to join the Matang matrimony WhatsApp group?",
                  answer: "No Matang matrimony WhatsApp group exists because of the privacy policy."
                },
                {
                  question: "What is the Matang matrimony login process?",
                  answer: "First, Matang Samaj Vadhu Var has to register through the MarathiVadhuVarSuchak.com site. After approval, you can sign in with your login credentials."
                },
                {
                  question: "How to search Matang matrimony photos, including profiles?",
                  answer: "After signing up and approval through the MarathiVadhuVarSuchak.com site, you can search Matang matrimony profiles with photos."
                },
                {
                  question: "How to find the Matang matrimony contact number?",
                  answer: "Visit MarathiVadhuVarSuchak.com site and click on contact us page for contact details."
                },
                {
                  question: "How to search for Matang brides online?",
                  answer: "Register free on MarathiVadhuVarSuchak.com to search for Matang brides' profiles online."
                },
                {
                  question: "How to search Matang divorced Matrimony profiles?",
                  answer: "Register free through the MarathiVadhuVarSuchak.com matrimony to search Matang Samaj divorced Vadhu Var profiles."
                },
                {
                  question: "How to search the Matang brides Maharashtra profiles?",
                  answer: "To search the Matang brides' Maharashtra profiles, register free on MarathiVadhuVarSuchak.com matrimony."
                },
                {
                  question: "How to search the Matang Vadhu photo profiles online?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimony for free registration and search the Matang Vadhu photo profiles online."
                },
                {
                  question: "Which is the best Matang Vadhu Var Suchak Kendra?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the best Matang Vadhu Var Suchak Kendra in Maharashtra."
                },
                {
                  question: "Which is the best Matang Vadhu Var Suchak Mandal Mumbai?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the best Matang Vadhu Var Suchak Mandal in Mumbai."
                },
                {
                  question: "How to search the Nar Matang Brides Profiles online?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony for free registration to search the Nar Matang Brides Profiles online."
                },
                {
                  question: "How to conduct the Matang Vadhu Var Melava?",
                  answer: "MarathiVadhuVarSuchak.com organizes Melava every quarter. So, keep visiting the website for latest update."
                },
                {
                  question: "Which is the best Matang Vadhu Var Suchak Mandal Dhankawadi?",
                  answer: "MarathiVadhuVarSuchak.com is the best Matang Vadhu Var Suchak Mandal to search profiles from Dhankawadi."
                },
                {
                  question: "Which is the best Matang brides Sadashiv Peth region?",
                  answer: "MarathiVadhuVarSuchak.com is the best site to search for Matang brides in the Sadashiv Peth region."
                },
                {
                  question: "How to join the Matang Vadhu Var WhatsApp group link?",
                  answer: "Due to the privacy policy, MarathiVadhuVarSuchak.com does not have a WhatsApp group link to join."
                },
                {
                  question: "Which is the best Matang Vadhu Var Suchak Mandal Pune?",
                  answer: "MarathiVadhuVarSuchak.com is the best Matang Vadhu Var Suchak Mandal for the Pune region."
                },
                {
                  question: "How to search for the Matang Vadhu photo online?",
                  answer: "Register free on MarathiVadhuVarSuchak.com site and start your Matang Vadhu photo search online."
                },
                {
                  question: "Which is the best Matang Samaj Matrimony in Maharashtra?",
                  answer: "MarathiVadhuVarSuchak.com is the best Matang Samaj Matrimony in Maharashtra."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Matang Matrimony for Matang Communities"
        items={communityServices}
      />

    </div>
  );
}
